import { from, split } from "@apollo/client/core";
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { getMainDefinition } from "@apollo/client/utilities";
import settingsData from "@/config/settings_data.json";
import { cartLink } from "@/core/api/graphql/cart/links";
import { errorHandlerLink } from "@/core/api/graphql/config/error-handler";
import { applyGatesLink } from "./apply-gates";
import { httpLink } from "./http";
import { operationTypeLink } from "./operation-type-link";
import { queuedMutationsLink } from "./queued-mutations/queued-mutations";
import { timeoutLink } from "./timeout";
import { wsLink } from "./ws";

const sharedLink = from([
  removeTypenameFromVariables(),
  applyGatesLink,
  ...(settingsData.settings.graphql_operation_marking_enabled ? [operationTypeLink] : []),
  timeoutLink,
  errorHandlerLink,
]);

// https://www.apollographql.com/docs/react/api/link/introduction/#composing-a-link-chain
// Tree:
// removeTypenameLink
// ↓
// applyGatesLink
// ↓
// errorHandlerLink
// ↓
// (conditional links)
// ↓
// wsLink/httpLink
export const link = from([
  sharedLink,
  // Add conditional links here
  queuedMutationsLink,
  cartLink,
  // Send only subscriptions through web sockets
  split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      // Disabled because importing this enums cause issues and graphql package will remove them at v17
      // https://virtocommerce.atlassian.net/browse/VCST-834
      // https://github.com/graphql/graphql-js/pull/3686
      // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
      return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    },
    wsLink,
    httpLink,
  ),
]);
